import React from 'react'
import { EloBaseIcon, EloBaseIconProps } from '../_base'

export const EloFlashIcon: React.FC<EloBaseIconProps> = (props) => (
  <EloBaseIcon {...props} viewBox='0 0 32 40'>
    <path
      d='M17.917 17.0635L17.9775 18.085H29.4609L11.6904 36.6621L14.0684 23.1885L14.293 21.915H2.22754L17.085 2.92871L17.917 17.0635Z'
      stroke='currentColor'
      fill='none'
      strokeWidth='2.16948'
    />
  </EloBaseIcon>
)
